'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _menuToggler = require('./menuToggler');

var _menuToggler2 = _interopRequireDefault(_menuToggler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ToggleElement(_ref) {
  var activateMenu = _ref.activateMenu,
      button = _ref.button,
      children = _ref.children,
      className = _ref.className,
      isActiveMenu = _ref.isActiveMenu;

  return _react2.default.createElement(
    'div',
    { className: className },
    _react2.default.createElement(
      'span',
      { className: 'Toggle_button ' + (isActiveMenu('menu') ? 'Toggle_buttonOpen' : ''), role: 'button', tabIndex: '0', onClick: activateMenu('menu'), onKeyDown: activateMenu('menu') },
      button
    ),
    isActiveMenu('menu') && children
  );
}

ToggleElement.propTypes = {
  button: _propTypes2.default.node,
  children: _propTypes2.default.node.isRequired,
  className: _propTypes2.default.string,
  activateMenu: _propTypes2.default.func.isRequired,
  isActiveMenu: _propTypes2.default.func.isRequired
};

ToggleElement.defaultProps = {
  button: undefined,
  className: undefined
};

exports.default = (0, _menuToggler2.default)(ToggleElement);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/ToggleElement.js
// module id = 1174
// module chunks = 0